import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoButtonPrimary, RaikoConfirmDialog,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoDivider,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoMaterialOutlinedInput,
    RaikoSimpleMultiLineInputOutlined,
    showErrorMessage, showSuccessMessage,RaikoLabel, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {useAuthState} from "../../context/AuthContext";
import {AccountService} from "../../serverService/account/AccountService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useEffect, useState} from "react";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {css} from "@emotion/css";

export default function AccountCheckoutDetail(
    {id}
) {

    const {fundID} = useAuthState()
    const service = new AccountService()

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [checkoutDetail, setCheckoutDetail] = useState({
        changedStatusAt: "",
        changedStatusBy: "",
        depositAccountId: "",
        depositAccountNumber: "",
        description: "",
        id: "",
        ownerFullName: "",
        sendAt: "",
        sendBy: "",
        status: ""
    });

    useEffect(() => {
        getDetailFromServer()
    }, [id]);

    function getDetailFromServer() {
        loading.show()
        service.getAccountCheckoutDetail(fundID, id)
            .then(response => {
                setCheckoutDetail(response)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    const ignoreIt = () => {
        //Nothing to do !!!!
    }

    function handleUpdateStatus() {
        if (checkoutDetail.newStatus === "REJECTED") {
            loading.show()
            service.rejectCheckoutRequest(
                fundID,
                checkoutDetail.id
            ).then(response => {
                showSuccessMessage("بروزرسانی وضعیت با موفقیت انجام شد.")
                setCheckoutDetail({
                    ...checkoutDetail,
                    status: "REJECTED"
                })
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        } else if (checkoutDetail.newStatus === "ACCEPTED") {
            handleOpenDialog()
        } else {
            showWarningMessage("لطفا ابتدا وضعیت بررسی را تغییر دهید.")
        }
    }

    const [confirmDialog, setConfirmDialog] = useState(false);
    const handleOpenDialog = () => setConfirmDialog(true)
    const handleCloseDialog = () => setConfirmDialog(false)

    function handleAcceptRequest() {
        loading.show()
        service.acceptCheckoutRequest(
            fundID,
            checkoutDetail.id
        ).then(response => {
            showSuccessMessage("بروزرسانی وضعیت با موفقیت انجام شد.")
            setCheckoutDetail({
                ...checkoutDetail,
                status: "ACCEPTED"
            })
            handleCloseDialog()
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }


    return (
        <>
            <RaikoConfirmDialog
                cancelAction={handleCloseDialog}
                openConfirmDialog={confirmDialog}
                doAction={handleAcceptRequest}
                pageTitle={"تسویه حساب کاربر"}
                warningTitle={"آیا از بستن حساب کاربر اطمینان دارید؟"}
                warningDescription={"با اتمام این فرایند حساب کاربر بسته خواهد شد و امکان بازگشت وجود ندارد."}
                confirmButtonTitle={"بستن حساب"}
            />

            <RaikoGridOneColumn className={css`padding: 1rem 0`}>
                <RaikoGridThreeColumn>
                    <RaikoMaterialOutlinedInput
                        labelText={"نام و نام خانوادگی"}
                        value={checkoutDetail.ownerFullName}
                        setValue={ignoreIt}
                        disabled
                    />
                    <RaikoMaterialOutlinedInput
                        labelText={"شناسه حساب"}
                        value={checkoutDetail.depositAccountNumber}
                        setValue={ignoreIt}
                        disabled
                    />
                    <RaikoMaterialOutlinedInput
                        labelText={"تاریخ ثبت"}
                        value={convertUniversalDateTimeToPersianDateTime(checkoutDetail.sendAt)}
                        setValue={ignoreIt}
                        disabled
                    />
                    <RaikoMaterialOutlinedInput
                        labelText={"ثبت کننده"}
                        value={checkoutDetail.sendBy}
                        setValue={ignoreIt}
                        disabled
                    />
                    <RaikoMaterialOutlinedInput
                        labelText={"ثبت کننده"}
                        value={checkoutDetail.changedStatusBy ? checkoutDetail.changedStatusBy : "رسیدگی نشده"}
                        setValue={ignoreIt}
                        disabled
                    />

                    <RaikoMaterialOutlinedInput
                        labelText={"رسیدگی کننده"}
                        value={checkoutDetail.changedStatusAt ? convertUniversalDateTimeToPersianDateTime(checkoutDetail.changedStatusAt) : "نامشخص"}
                        setValue={ignoreIt}
                        disabled
                    />
                </RaikoGridThreeColumn>
                <RaikoSimpleMultiLineInputOutlined
                    labelText={"توضیحات درخواست"}
                    value={checkoutDetail.description}
                    setValue={ignoreIt}
                    disabled
                />
                <RaikoDivider/>
                <RaikoLabel text={"دسترسی ها"} className={css`width: 100%;
                  text-align: start;`}/>
                <div className={css`
                  display: flex;
                  gap: .75rem`
                }>
                    <RaikoCustomSelect
                        labelText={"وضعیت"}
                        value={checkoutDetail.newStatus ? checkoutDetail.newStatus : checkoutDetail.status}
                        setValue={newStatus => {
                            setCheckoutDetail({
                                ...checkoutDetail,
                                newStatus: newStatus
                            })
                        }}
                        disabled={checkoutDetail.status === "ACCEPTED" || checkoutDetail.status === "REJECTED"}
                        items={
                            [
                                raikoCustomSelectItemGenerator("AWAITING_FOR_REVIEW", "در انتظار بررسی"),
                                raikoCustomSelectItemGenerator("ACCEPTED", "پذیرفته شده"),
                                raikoCustomSelectItemGenerator("REJECTED", "رد شده"),
                            ]
                        }/>
                    {
                        checkoutDetail && checkoutDetail.status === "AWAITING_FOR_REVIEW" &&
                        <RaikoButtonPrimary
                            label={"بروزرسانی"}
                            onClick={handleUpdateStatus}
                        />
                    }
                </div>
            </RaikoGridOneColumn>
        </>
    )
}
